export default "__VITE_ASSET__D8z6uceQ__"